import { createNavigation } from 'next-intl/navigation';

import { routing } from 'src/i18n/routing';

const { Link } = createNavigation(routing);

export { Link as RouterLink };
